import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.push.js";
import { register, verificationCode } from '@/api/user';
import { isPhone, isEmail } from '@/utils/validate';
import $ from 'jquery';
var sha1 = require('sha1');
export default {
  data: function data() {
    return {
      isActive: false,
      checked: false,
      userName: '',
      verificationCode: '',
      password: '',
      verifyPassword: '',
      countryCode: localStorage.getItem('countryCode') || '+86',
      country: localStorage.getItem('country') || 'china',
      type: 'password',
      verifyType: 'password'
    };
  },
  mounted: function mounted() {},
  methods: {
    input: function input() {
      if (this.userName.trim() !== '' && this.password.trim() !== '' && this.verificationCode.trim() !== '' && this.verifyPassword.trim() !== '' && this.verifyPassword === this.password) {
        if (isPhone(this.userName) || isEmail(this.userName)) {
          this.isActive = true;
        } else {
          this.isActive = false;
        }
      } else {
        this.isActive = false;
      }
    },
    getCountry: function getCountry() {
      this.$router.push({
        path: '/selectCountry'
      });
    },
    focus: function focus(dom) {
      $(dom).css('border-image', '-webkit-linear-gradient(#6EDCF5 0%, #6EDCF5 100%) 0 0 100 0');
    },
    blur: function blur(dom) {
      $(dom).css('border-image', 'none');
    },
    showWord: function showWord(type) {
      if (type === 'password') {
        this.type = 'text';
      } else {
        this.type = 'password';
      }
    },
    showVerifyWord: function showVerifyWord(type) {
      if (type === 'password') {
        this.verifyType = 'text';
      } else {
        this.verifyType = 'password';
      }
    },
    send: function send() {
      var _this = this;
      var params = {};
      params.targetName = this.userName;
      params.operationType = 0;
      if (isPhone(this.userName)) {
        params.countryCode = this.countryCode;
        params.targetType = 1;
      } else {
        if (isEmail(this.userName)) {
          params.targetType = 2;
          delete params.countryCode;
        } else {
          if (this.userName) {
            this.$toast('用户名格式不正确');
          } else {
            this.$toast('请输入用户名');
          }
          return;
        }
      }
      verificationCode(params).then(function (res) {
        if (res.code === 0) {
          _this.$toast('发送完成');
        } else {
          _this.$toast(res.message);
        }
      });
    },
    toRegister: function toRegister() {
      var _this2 = this;
      var params = {};
      params.userName = this.userName;
      params.verificationCode = this.verificationCode;
      params.password = sha1(this.password);
      params.deviceId = '123456';
      if (this.userName.trim() !== '' && this.password.trim() !== '' && this.verificationCode.trim() !== '' && this.verifyPassword.trim() !== '' && this.verifyPassword === this.password) {
        if (this.checked) {
          if (isPhone(this.userName)) {
            params.countryCode = this.countryCode;
            params.registerType = 1;
          } else {
            if (isEmail(this.userName)) {
              params.registerType = 2;
              delete params.countryCode;
            } else {
              this.$toast('用户名格式不正确');
              return;
            }
          }
        } else {
          this.$toast('未同意条款');
          return;
        }
      } else {
        if (this.verifyPassword === this.password) {
          this.$toast('请输入完整信息');
        } else {
          this.$toast('两次输入的密码不一致');
        }
        return;
      }
      register(params).then(function (res) {
        if (res.code === 0) {
          console.log(res, 'register');
        } else {
          _this2.$toast(res.message);
        }
      });
    },
    back: function back() {
      this.$router.back();
    },
    toLogin: function toLogin() {
      this.$router.push({
        path: '/login'
      });
    }
  }
};